var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"mx-5 my-7",attrs:{"cols":"12","width":"100%"}},[_c('v-col',{attrs:{"cols":"12 text-left"}},[_vm._t("text",function(){return [_c('div',{domProps:{"innerHTML":_vm._s(_vm.contentData.text)}})]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }